import lgm from '../images/lgm.jpg';
import agilysys from '../images/agilysys.png';
import dipeat from '../images/dipeat.png';

const ExperienceData = [
    {
        company : 'Agilysys India Private Limited',
        link : 'https://www.agilysys.com/',
        role : 'Associate Software Analyst',
        responsibility: [
            'Proficient in .NET technologies, focusing on maintaining product stability and enhancing seamless deliverables for improved user experience and performance.'
        ],
        duration : 'July 2024 - Present',
        logo : agilysys
    },
    
    {
        company : 'Dipeat Foods Private Limited',
        link : 'https://dipeat.com/',
        role : 'Web and Mobile Application Developer (Internship)',
        responsibility: [
            'Design and manage the company website\'s UI with Vue.js for an intuitive, visually appealing, and creative user experience across all devices.',
            'Develop a React Native app for the company, enhancing its portfolio and gaining valuable experience in mobile app development.'
        ],
        duration : 'October 2023 - November 2023',
        logo : dipeat
    },
    {
        company : 'Let\'s Grow More',
        link : 'https://letsgrowmore.in/',
        role : 'Web Developer (Internship)',
        responsibility: [
            'Successfully tackled the tasks , optimizing website performance and honing my skills in web development using React Js .',
            
        ],
        duration : 'August 2023',
        logo : lgm
    },
]

export default ExperienceData